import { OCRResultDTO } from '../generated';
import { fileApi, ocrApi } from '../generated/clients';

export const mapFileToRequestBody = (file: Blob) => {
  const formData = new FormData();
  formData.append('file', file);
  return { body: formData };
};

export const uploadFile = async (file: File): Promise<string> => {
  const response = await (await fileApi.fileUploadFileRaw(mapFileToRequestBody(file))).raw.json();
  const fileId = response.fileId;
  return fileId;
};

export const serverOcr = async (file: Blob): Promise<OCRResultDTO> => {
  const response = await ocrApi.oCRExtractText(mapFileToRequestBody(file));
  return response;
};
